import request from "../utils/request";

// H5 匿名登录 / 初始化：不传参；已有身份时可能不返回 token
export function userInit(extraConfig = {}) {
  return request({
    url: "/User/init",
    method: "post",
    hideToastDialg: true,
    ...extraConfig,
  });
}

// 获取用户信息
export function getInfo(data, extraConfig = {}) {
  return request({
    url: "/User/getInfo",
    method: "post",
    data,
    ...extraConfig,
  });
}

// 本地渠道变更上报（与上一次生效渠道不一致时由前端调用）
export function saveChannelChange(data) {
  return request({
    url: "/User/saveChannelChange",
    method: "post",
    data,
    hideToastDialg: true,
    ignoreErrors: true,
  });
}

// 判断是否去tiktok小城
export function getRedirectUrl(data) {
  return request({
    url: "/User/getRedirectUrl",
    method: "post",
    data,
    hideToastDialg: true,
  });
}

